import type { CursorState, HoverState } from "./layout";

export function TimelineCursor({ cursor }: { cursor: CursorState | null }) {
  if (!cursor) return null;
  return (
    // Dynamic-from-JS: leftPx tracks live mouse position via rAF-throttled
    // state. Keep inline.
    <div className="tl-cursor" style={{ left: cursor.leftPx }}>
      <div className="tl-cursor-label">
        {new Date(cursor.timeMs).toLocaleString("en-US", {
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit",
        })}
      </div>
    </div>
  );
}

export function TimelineTooltip({ hover }: { hover: HoverState | null }) {
  if (!hover) return null;
  return (
    // Dynamic-from-JS: left + top are bounding-rect-derived pixel coords for
    // the hovered bar. Keep inline.
    <div className="tl-tooltip" style={{ left: hover.left, top: hover.top }}>
      {hover.lines.map((line) => (
        <div key={line} className="tl-tooltip-line">
          {line}
        </div>
      ))}
    </div>
  );
}
